import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const setTypeReview = api(async function setTypeReview({
    id,
    type,
    reviewStatus,
    reviewedTypeName,
    reviewedParent,
}) {
    return mutate(
        gql`
            mutation SetTypeReview(
                $id: String!
                $type: String!
                $reviewStatus: ReviewStatus!
                $reviewedTypeName: String
                $reviewedParent: String
            ) {
                setTypeReview(
                    id: $id
                    type: $type
                    reviewStatus: $reviewStatus
                    reviewedTypeName: $reviewedTypeName
                    reviewedParent: $reviewedParent
                )
            }
        `,
        { id, type, reviewStatus, reviewedTypeName, reviewedParent },
        { returns: "setTypeReview" }
    )
})
